<template>
  <NuxtLayout name="base">
    <slot />
  </NuxtLayout>
</template>
